module.exports = __webpack_public_path__ + "img/delete.d9d21287.svg";